var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8568 21.1708H17.5235V17.8374H19.9139L20.8568 16.8845V13.7804L19.9139 12.8374H15.8568V21.1708ZM17.5235 16.1708V14.5041H19.1902V16.1708H17.5235ZM22.4339 21.1708H26.491L27.4339 20.2179V13.7804L26.491 12.8374H22.4339V21.1708ZM24.1006 19.5041V14.5041H25.7672V19.5041H24.1006ZM29.041 21.1708H30.7077V17.8374H32.3743V16.1708H30.7077V14.5041H32.3743V12.8374H29.041V21.1708ZM10.4585 30.6762V3.33203H37.8027V30.6762H10.4585ZM14.2502 26.8845H34.011V7.1237H14.2502V26.8845ZM3.3335 37.8012V10.457H7.12516V34.0095H30.6777V37.8012H3.3335Z",
    fill: "#184BC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDFIcon.6f63f25b114e6c8f84869f51a66593d5.svg";
export { ForwardRef as ReactComponent };